import React from 'react'

import { parsePhone } from 'services/Utilities'

const UserEmergencyContacts = ({ emergencyContacts = [] }) => {
  return emergencyContacts.length
    ? emergencyContacts.map((emergencyContact, index) => (
        <div className="text-nowrap" key={index}>
          <div>
            {emergencyContact.name} {parsePhone(emergencyContact.phoneNumber)}
          </div>
          {emergencyContact.relation ? <small className="text-muted d-block">{emergencyContact.relation}</small> : null}
        </div>
      ))
    : null
}

export default UserEmergencyContacts
